import axios from "axios";
import otpResponse, { otp, otpRequest, otpVerifyRequest } from "../../../types/registration/registerTypes";
import apiClient from "../client";
import { toast } from "react-toastify";

export interface ExistingUserCheck {
  exists: boolean;
  count: number;
  existingLocations: Array<{ id: string; name: string; status: string }>;
}

export const checkExistingUser = async (email?: string, mobile?: string): Promise<ExistingUserCheck> => {
  try {
    const params = new URLSearchParams();
    if (email) params.append('email', email);
    if (mobile) params.append('mobileNumber', mobile);
    const response = await apiClient.get(`/foodcourt/foodcourts/check-exists?${params.toString()}`);
    return response.data || { exists: false, count: 0, existingLocations: [] };
  } catch {
    return { exists: false, count: 0, existingLocations: [] };
  }
};

export const checkStatusWithOtp = async (mobileNumber: string, otpCode: string): Promise<ExistingUserCheck> => {
  const response = await apiClient.post('/foodcourt/foodcourts/check-status', { mobileNumber, otpCode });
  return response.data || { exists: false, count: 0, existingLocations: [] };
};

export const lookupIfsc = async (ifsc: string): Promise<{ bank: string; branch: string } | null> => {
  try {
    const res = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
    if (!res.ok) return null;
    const data = await res.json();
    return { bank: data.BANK || '', branch: data.BRANCH || '' };
  } catch { return null; }
};

export const lookupGstin = async (gstin: string): Promise<{ name: string; address: string } | null> => {
  try {
    const res = await fetch(`https://sheet.best/api/sheets/d4787e7d-c585-4c18-8f0d-0e4e30c9a1ab/GSTIN/${gstin}`);
    if (!res.ok) return null;
    const data = await res.json();
    if (data && data.length > 0) {
      return { name: data[0].LegalName || data[0].TradeName || '', address: data[0].Address || '' };
    }
    return null;
  } catch { return null; }
};

export const fetchOtp = async (data: otpRequest): Promise<otpResponse> => {
  const response = await apiClient.post<otpResponse>(`/foodcourt/foodcourts/send-otp?mobileNumber=${data.mobileNumber}`);
  return response.data;
};


export const verifyCode = async (data: otpVerifyRequest): Promise<otpResponse> => {
  const response = await apiClient.post<otpResponse>(`/foodcourt/foodcourts/verify-otp`,data);
  return response.data;
};

export const resendOtp = async (phonenumber:string): Promise<otp> => {
  const response = await apiClient.post<otp>(`/customer/customer/resend_otp?mobileNumber=${phonenumber}`);
  return response.data;
};  


export const registerFoodcourt = async (formData: FormData): Promise<otpResponse> => {
  try {
    const response = await apiClient.post('/foodcourt/foodcourts', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // Check if the response status is 409
        if (error.response.status === 409) {
          toast.error(error.response.data.message);  // Display the error message from the response
        } else {
          // Handle other status codes if necessary
          toast.error('An unexpected error occurred');
        }
      } else {
        // The error was triggered by something else, not a response from the server
        toast.error('Network error or server did not respond');
      }
    } else {
      // Not an Axios error, handle differently or re-throw
      toast.error('An unexpected error occurred');
    }
    throw error;  // Re-throw to allow further handling or to signal failure upstream
  }
};
